import React from 'react';
import type { FabricCanvas } from '../../types/fabric';
import { useDesignStore } from '../../store/designStore';
import { useTranslation } from 'react-i18next';

// Info panel content rendered inside the left slide-in panel when the user
// clicks the "Info" sidebar icon. Admin configures the title + description
// lines per layout (layoutConfig.infoPanel.title / .lines).
export function InfoPanel(_: { canvas?: FabricCanvas | null }) {
  const { t } = useTranslation();
  const infoPanel = useDesignStore(s => s.layoutConfig.infoPanel);
  if (!infoPanel?.enabled) return null;

  return (
    <div style={{ padding: 16 }}>
      <div style={{
        fontWeight: 600,
        fontSize: 14,
        color: '#1e293b',
        marginBottom: 12,
        paddingBottom: 8,
        borderBottom: '1px solid #f1f5f9',
      }}>
        {infoPanel.title || t('sidebar.info')}
      </div>
      {(infoPanel.lines ?? []).map((line, i) => (
        <p key={i} style={{ fontSize: 13, color: '#475569', margin: '0 0 8px', lineHeight: 1.6 }}>
          {line}
        </p>
      ))}
      {(infoPanel.lines ?? []).length === 0 && (
        <p style={{ fontSize: 13, color: '#94a3b8', fontStyle: 'italic' }}>
          {t('sidebar.infoEmpty')}
        </p>
      )}
    </div>
  );
}
